import { Skeleton } from "../../ui";

const ProductSkeleton = ({productCols}) => (
  <>
    {
      productCols === 1 ?
        <div className="h-full flex flex-col items-center justify-center">
          <div className="w-full flex flex-col items-end justify-start my-2">
            <Skeleton height={38} width="30%" className="my-1"/>
            <Skeleton height={26} className="my-1"/>
            <Skeleton height={26} className="my-1"/>
          </div>
          <div className="w-full flex justify-between items-end mt-1">
            <Skeleton height={45} width="28%"/>
            <Skeleton height={45} width="68%"/>
          </div>
        </div>
        :
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
          <div className="h-full flex flex-col items-center justify-center">
            <Skeleton className="w-full aspect-square max-w-[400px]"/>
          </div>
          <div className="h-full flex flex-col items-start justify-start px-2">
            <Skeleton height={30} className="my-2"/>
            <Skeleton height={30} width="60%" className="my-2"/>
            <Skeleton height={65} className="my-3"/>
            <div className="w-full flex justify-between items-end my-2 gap-2">
              <Skeleton height={55} className="flex-1"/>
              <Skeleton height={80} className="flex-1"/>
            </div>
            <div className="w-full flex flex-col items-start justify-start my-2">
              <Skeleton height={25} width="30%" className="my-1"/>
              <Skeleton height={25} className="my-1"/>
              <Skeleton height={25} className="my-1"/>
            </div>
            <div className="w-full flex justify-between items-end my-4 gap-2">
              <Skeleton height={45} width="28%"/>
              <Skeleton height={45} width="68%"/>
            </div>
            <div className="w-full flex flex-col items-start justify-start">
              <Skeleton height={100} className="my-2"/>
            </div>
          </div>
        </div>
    }
  </>
)

export default ProductSkeleton
